<template>
  <div class="inputNumber-modular">
    <div :class="(showNumber == 0 ? 'reduce reduce-0' : 'reduce')" @click="reduceNubmer()">-</div>
    <div class="nubmer">{{ showNumber }}</div>
    <div class="add" @click="addeNubmer()">+</div>
  </div>
</template>
<script>
export default {
  name: "inputNumber",

  data() {
    return {
      showNumber: 1
    };
  },
  methods: {
    // 数量减
    reduceNubmer() {
      if (this.showNumber != 1) {
        this.showNumber--;
        this.$parent.setProductNum(this.index, this.showNumber)

      }
    },
    // 数量加
    addeNubmer() {
      this.showNumber++;
      this.$parent.setProductNum(this.index, this.showNumber)
    }
  },
  mounted() {
    let that = this;
    that.showNumber = this.number;
  },
  props: ["number", "index"],
};
</script>

<style lang="scss">
.inputNumber-modular {
  display: flex;

  .reduce {
    cursor: pointer;
    width: 34px;
    height: 34px;
    background-color: #F0F0F0;
    text-align: center;
    line-height: 34px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

  }

  .reduce-0 {
    color: #CCCCCC;
  }

  .nubmer-input {
    padding: 0;
    text-align: center;
    height: 34px;
    background-color: #F0F0F0 !important;
    line-height: 34px;
    border: 0;
    color: #606266 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    width: 38px;
    margin: 0 5px;
  }

  .nubmer {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    width: 38px;
    margin: 0 5px;
    padding: 0;
    text-align: center;
    height: 34px;
    background-color: #F0F0F0 !important;
    line-height: 34px;
    border: 0;
    color: #606266 !important;
  }


  .add {
    cursor: pointer;
    width: 34px;
    height: 34px;
    background-color: #F0F0F0;
    text-align: center;
    line-height: 34px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/InputNumber.vue